// extracted by mini-css-extract-plugin
module.exports = {"main":"_hV","wrapper":"_hW","container":"_hX","content":"_hY","sidebar":"_hZ"};